import React from "react";
import MultipleSelect from '../common/dropdown/Dropdown.component';
import SingleSelect from '../common/dropdown/SingleSelect.component';
import useNewReportStyles from "./newReport.style"
// import axios from 'axios';

const Dropdown = (props) => {
    const {
        label,
        getLabel,
        labelKey,
        multiSelect,
        onChange,
        defaultValue
    } = props

    const classes = useNewReportStyles()
    // const [loading, setLoading] = React.useState(true);
    // const [error, setError] = React.useState('');
    // const [data, setData] = React.useState([]);
    // const uniq_url = getLabel;
    // const uniq_url="";
    // React.useEffect(() => {
    //     setLoading(true);
    //     axios.get(uniq_url)
    //         .then((response) => {
    //             setLoading(false);
    //             setData(response.data);
    //             console.log("fetch", response.data);
    //         }).catch((e) => {
    //             setLoading(false);
    //             setError('fetch failed');

    //         });
    // },[]);

    return (
        <div style={{ padding: "0px 18px", margin: "20px 5px" }}>
            <div className={classes.label}>{label}</div>
            {multiSelect ?
                <MultipleSelect items={getLabel} defaultValue={defaultValue} labelKey={labelKey} onChange={onChange} /> : <SingleSelect defaultValue={defaultValue} items={getLabel} labelKey={labelKey} onChange={onChange} />}

        </div>
    )
}

export default Dropdown;